
const initialState = {
    pageParams:{}
}

export default (state=initialState,action)=>{
    switch(action.type){
        default :
            return state
    }
}